import React, { createContext, useState } from "react";

// Create the context
export const AccountContext = createContext();

// Create the provider component
export const AccountProvider = ({ children }) => {
  const [whatAccount, setWhatAccount] = useState(null);
  const [clientAccounts, setAccounts] = useState([]);
  const [googleCategories, setGoogleCategories] = useState([]);
  const [userAccounts, setUserAccounts] = useState([]);
  const [actionButtons, setActionButtons] = useState([]);
  const [activeClient, setActiveClient] = useState([]);
  const [activeOutlet, setActiveOutlet] = useState([]);
  const [masked, setMasked] = useState(false);
  const [originalID, setOriginalID] = useState('');
  const [myAccount, setMyAccount] = useState([]);
  const [clientActiveLocation, setClientActiveLocation] = useState(null); // Added state

  // Updaters
  const updateWhatAccount = (account) => setWhatAccount(account);
  const updateClientAccounts = (newAccounts) => setAccounts(newAccounts);
  const updateGoogleCategories = (categories) => setGoogleCategories(categories);
  const updateUserAccounts = (users) => setUserAccounts(users);
  const updateActionButtons = (users) => setActionButtons(users);
  const updateActiveClient = (users) => setActiveClient(users);
  const updateActiveOutlet = (users) => setActiveOutlet(users);
  const updateMasked = (boolean) => setMasked(boolean);
  const updateOriginalID = (boolean) => setOriginalID(boolean);
  const updateMyAccount = (lgo) => setMyAccount(lgo); // Fixed: should update myAccount
  const updateClientActiveLocation = (location) => setClientActiveLocation(location); // Added updater

  return (
    <AccountContext.Provider
      value={{
        whatAccount,
        clientAccounts,
        googleCategories,
        userAccounts,
        actionButtons,
        activeClient,
        activeOutlet,
        masked,
        originalID,
        myAccount, // used for the LGO Account
        clientActiveLocation, // Added to context value
        updateWhatAccount,
        updateClientAccounts,
        updateGoogleCategories,
        updateUserAccounts,
        updateActionButtons,
        updateActiveClient,
        updateActiveOutlet,
        updateMasked,
        updateOriginalID,
        updateMyAccount,
        updateClientActiveLocation, // Added to context value
      }}
    >
      {children}
    </AccountContext.Provider>
  );
};
